export const DEFAULT_LOCALE = 'en-US';
export const DEFAULT_TIME_ZONE = 'UTC';

const normalizeDate = (value: Date | string | number | null | undefined): Date | null => {
    if (!value) return null;
    const date = value instanceof Date ? value : new Date(value);
    if (Number.isNaN(date.getTime())) return null;
    return date;
};

export const formatNumber = (
    value: number | null | undefined,
    options: Intl.NumberFormatOptions = {},
): string => {
    if (value === null || value === undefined || Number.isNaN(value)) return '';
    return value.toLocaleString(DEFAULT_LOCALE, options);
};

export const formatDate = (
    value: Date | string | number | null | undefined,
    options: Intl.DateTimeFormatOptions = {},
): string => {
    const date = normalizeDate(value);
    if (!date) return '';
    return date.toLocaleDateString(DEFAULT_LOCALE, {timeZone: DEFAULT_TIME_ZONE, ...options});
};

export const formatDateTime = (
    value: Date | string | number | null | undefined,
    options: Intl.DateTimeFormatOptions = {},
): string => {
    const date = normalizeDate(value);
    if (!date) return '';
    return date.toLocaleString(DEFAULT_LOCALE, {timeZone: DEFAULT_TIME_ZONE, ...options});
};

type PriceData = {
    amount?: number | null;
    currency?: string | null;
    display?: string | null;
};

export const formatPrice = (price?: PriceData | null): string => {
    if (!price) return '';
    if (price.display) return price.display;
    if (price.amount === null || price.amount === undefined || Number.isNaN(price.amount)) return '';

    if (price.currency) {
        try {
            return price.amount.toLocaleString(DEFAULT_LOCALE, {
                style: 'currency',
                currency: price.currency,
                maximumFractionDigits: Number.isInteger(price.amount) ? 0 : 2,
            });
        } catch {
            // Fall through to a numeric format.
        }
    }

    const fractionDigits = Number.isInteger(price.amount) ? 0 : 2;
    return formatNumber(price.amount, {
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits,
    });
};
